// 特殊な動作を行う点検を判断するための情報
export const INSPECT_VALUE_VIEW_TYPE = {
  BATTERY:     1, // バッテリー
  TIRE:        2, // タイヤ
  SIDE_SLIP:   3, // サイドスリップ
  BRAKE:       4, // 前ブレーキ
  SPEED:       5, // スピードメーター
  BRAKE_REAR:  6, // 後ブレーキ
  SUNFLARE:    7, // サンフレア
  BOOTS:       8, // ブーツ系列
  BASIC_OBD:   9, // OBD検査項目
  SYNC_OBD:   10, // OBD検査項目(警告灯連動)
  GROUND_CLR: 11, // 最低地上高連動
};

// 値を配列で持っている点検項目の設計情報
export const INSPECT_VALUE_LENGTH = [
  0, // 通常
  1, // BATTERY
  4, // TIRE
  1, // SIDE_SLIP
  2, // BRAKE
  1, // SPEED
  2, // BRAKE_REAR
  2, // SUNFLARE
  1, // BOOTS
  0, // OBD1
  0, // OBD2
  0, // GRAND_CLEARANCE
];
